import { api, getFiltersTagsMap } from '@creditsights/api-ui-web';
import { PageComponent } from '../../models';
import { IssuerDto } from '../dtos/issuer/issuer.dto';
import { IssuerListDto } from '../dtos/issuer/issuerList.dto';
import { IssuerSearchResultDto } from '../dtos/issuer/issuerSearchResult.dto';
import { SearchRequestBodyDto } from '../dtos/search/searchRequestBody.dto';
import { IssuersQueryParams } from './issuersQueryParams';

export const issuersModuleV1Uri = '/common/v1/issuers';
export const getFetchIssuerUrl = (tag: string): string => `${issuersModuleV1Uri}/${tag}`;
export const getFetchPageComponent = (issuerTag: string, componentTagId: string): string =>
  `${issuersModuleV1Uri}/${issuerTag}/components/component/${componentTagId}`;

export const fetchIssuers = async (params: IssuersQueryParams): Promise<IssuerListDto> => {
  const { data } = await api.post(issuersModuleV1Uri, params);
  const tagsMap = await getFiltersTagsMap();
  return {
    ...data,
    results: data.results?.map((issuer) => ({
      ...issuer,
      implied: issuer.implied?.map((tagId) => tagsMap[tagId]).filter(Boolean),
    })),
  };
};

export const fetchIssuer = async (tag: string): Promise<IssuerDto> => {
  const { data } = await api.get(getFetchIssuerUrl(tag));
  return data;
};

export const fetchIssuerSearch = async (
  requestBody: SearchRequestBodyDto,
  page = 0
): Promise<IssuerSearchResultDto> => {
  const { data } = await api.post<IssuerSearchResultDto>(`${issuersModuleV1Uri}/search`, {
    ...requestBody,
    skip: page * (requestBody.take ?? 0),
  });
  return data;
};

export const fetchPageComponents = async (tag: string): Promise<PageComponent[]> => {
  const { data } = await api.get(`${issuersModuleV1Uri}/${tag}/components`);
  return data;
};
export const fetchPageComponent = async (issuerTag: string, componentTagId: string): Promise<PageComponent> => {
  const { data } = await api.get(getFetchPageComponent(issuerTag, componentTagId));
  return data;
};
